import type { WhitelabelVariantDefinition } from '../../types';

export const mediamagWhitelabel = {
  id: 'mediamag',
  colors: {
    primary: {
      900: '#2D2A24',
      800: '#3A372E',
      700: '#595447',
      500: '#817D73',
      300: '#BDBBB5',
      100: '#EEEEED',
      contrastText: '#FFFFFF',
    },
  },
} as const;

export const mediamagDefaultTheme: WhitelabelVariantDefinition = {
  palette: {
    primary: {
      darker: mediamagWhitelabel.colors.primary[900],
      dark: mediamagWhitelabel.colors.primary[800],
      main: mediamagWhitelabel.colors.primary[700],
      light: mediamagWhitelabel.colors.primary[500],
      lighter: mediamagWhitelabel.colors.primary[300],
      muted: mediamagWhitelabel.colors.primary[100],
      contrastText: mediamagWhitelabel.colors.primary.contrastText,
    },
  },
};
